<div class="modal-property">
    <div class="header">
        <span>PUBLIC RECORDS RESULT</span>
        <span (click)="onDismiss()"
              class="dismiss"><i class="fas fa-times"></i></span>
    </div>
    <div class="body">
        <div class="properties">
            <span class="which">
                Multiple properties have been found, please select one:
            </span>
            <div class="header-list">
                <div class="address">
                    {{data.description}}
                </div>

                <span class="amount"><i class="fas  fa-home "></i> ({{publicRecords.length}})</span>
            </div>
            <div class="header-values">
                <div class="address-value">ADDRESS</div>
                <div class="apn-value">APN / TAX-ID</div>
            </div>
            <div class="list-property">
                <cv-public-record-item *ngFor="let publicRecord of publicRecords; let i = index"
                                       [publicRecord]="publicRecord"
                                       (click)="updateSelected(i)"
                                       [selected]="i===selected">

                </cv-public-record-item>
            </div>
        </div>
        <div class="detail-property">
            <cv-public-record-detail [publicRecord]="publicRecords[selected]"
                                     (usAsSubjectEvent)="usAsSubjectEvent($event)">

            </cv-public-record-detail>
        </div>

    </div>
</div>
